module.exports = __webpack_public_path__ + "img/R6__0628.e51e87b6.jpeg";